var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{class:_vm.cssClass,attrs:{"loading":_vm.loading,"disabled":_vm.disabled,"data-qa":_vm.dataQa},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.$t(_vm.text)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }